<template>
  <div class="license">
    <StartTopBar/>
    <div class="container-sm">
      <div v-if="!loading" class="row">
        <div class="col">
          <h4 class="text-left font-weight-bold text-danger">Laopeh Says is distributed under the Creative Commons BY-NC-SA 2.0 license.</h4>
          <a class="mb-4" href="https://creativecommons.org/licenses/by-nc-sa/2.0/">Creative Commons BY-NC-SA 2.0 license</a>
          <hr>
          <h6>This is a free and unofficial online clone of "Limpeh Says". We are not associated with, or supported/paid/endorsed by the original creators of "Limpeh Says" in any way.</h6>
          <h6>We have no intention to request for payment or donations through this site. All server and domain costs are borne personally by the creators of this game site.</h6>
          <h6>We strive to keep within the Creative Commons BY-NC-SA 2.0 license. If any party believes that we are not adhering to it, kindly email to monabstudios@gmail.com and we will amend accordingly.</h6>
          <h6>Note: "Monabstudios" is not a commercial entity and is a personal pasttime of the creators of this game site.</h6>
          <h6>"Limpeh Says" and the Limpeh Says logos are trademarks of Tan Yong Heng and Grouch Potato Games.</h6>
          <hr>
          <h5>Changes/modifications made:</h5>
          <h6>Created an online turn-based game accessible on laopehsays.com.</h6>
          <h6>Allow players to switch hands.</h6>
          <hr>
          <h6>For access to the codebase, kindly email monabstudios@gmail.com and we will email you the code repository used for the development of this game.</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StartTopBar from '@/components/StartTopBar'

export default {
  name: 'License',
  components: {
    StartTopBar
  },
  data(){
    return{
    }
  },
  methods: {
    track () {
      this.$gtag.pageview({
        page_path: '/join-game',
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/License.vue